import React from "react";
import "./Gdfooter.css";

export default function Gdfooter() {
  return (
    <footer className="ft">
      <div className="ft__container">
        <div className="ft__grid">
          {/* Left */}
          <section className="ft__col" aria-label="Hỗ trợ khách hàng">
            <h3 className="ft__title">HỖ TRỢ KHÁCH HÀNG</h3>

            <div className="ft__block">
              <div className="ft__company">quetrutthetindung.com</div>

              <div className="ft__line">
                <span className="ft__label">Địa chỉ:</span>{" "}
                <span className="ft__text">
                  Thôn Văn Cao, Xã Tảo Dương Văn, Huyện Ứng Hòa, Thành Phố Hà
                  Nội
                </span>
              </div>
              <div className="ft__line">
                <span className="ft__label">
                  Email: raumuongluoc171@gmail.com
                </span>{" "}
              </div>
              <div className="ft__line">
                <span className="ft__label">Hotline:</span>{" "}
                <a className="ft__link" href="tel:0824103709">
                  0824 103 709
                </a>
              </div>
            </div>
          </section>

          {/* Right */}
          <section className="ft__col" aria-label="Về chúng tôi">
            <h3 className="ft__title">VỀ CHÚNG TÔI</h3>

            <ul className="ft__list">
              <li>
                <a className="ft__link" href="/privacy">
                  Chính sách bảo mật
                </a>
              </li>
            </ul>
          </section>
        </div>
      </div>
    </footer>
  );
}
